var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomTable',{ref:"monte_resa",attrs:{"id_table":"monte_resa_commande","primaryKey":"id","items":_vm.items,"busy":_vm.table_busy,"hrefsRoutes":_vm.config_table_hrefs,"base-filters":_vm.tableFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }